import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconLink({ color = 'black', className, ariaHidden = false }: IconProps): ReactElement {
    return (
        <svg
            height='12'
            viewBox='0 0 12 12'
            width='12'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            aria-hidden={ariaHidden}
        >
            <g fill={color} fillRule='evenodd' transform='translate(.588619 .583333)'>
                <path
                    d='m-1.11111111 5h13.04498351v.83333333h-13.04498351z'
                    transform='matrix(-.70710678 .70710678 .70710678 .70710678 5.407643 -2.239919)'
                />
                <path d='m9.57838023.41666667h.33333334c.27614233 0 .50000003.22385762.50000003.5v6.30555555c0 .23011865-.1865481.41666667-.4166667.41666667-.23011865 0-.41666667-.18654802-.41666667-.41666667z' />
                <path
                    d='m6.88393579-2.77777778h.33333333v6.80555556c0 .23011864-.18654802.41666666-.41666666.41666666-.23011865 0-.41666667-.18654802-.41666667-.41666666v-6.30555556c0-.27614237.22385762-.5.5-.5z'
                    transform='matrix(0 1 -1 0 7.633935 -5.967269)'
                />
                <path
                    d='m4.99394382 8.47145204h1.80709591c.23011865 0 .41666667.18654803.41666667.41666667 0 .23011865-.18654802.41666667-.41666667.41666667h-1.80709591z'
                    transform='matrix(0 -1 -1 0 14.993944 14.993944)'
                />
                <path
                    d='m3.55026955 6.94444444h.33333334v6.11111116h-.33333334c-.27614237 0-.5-.2238577-.5-.5v-5.11111116c0-.27614237.22385763-.5.5-.5z'
                    transform='matrix(0 -1 -1 0 13.466936 13.466936)'
                />
                <path d='m.82804733 4.30555556h1.80709591c.23011865 0 .41666667.18654802.41666667.41666666 0 .23011865-.18654802.41666667-.41666667.41666667h-1.80709591z' />
                <path d='m.91138066 4.30555556h.33333334v6.11111114h-.33333334c-.27614237 0-.5-.2238577-.5-.50000003v-5.11111111c0-.27614238.22385763-.5.5-.5z' />
            </g>
        </svg>
    );
}
